import Vue from 'vue'
import App from './App.vue'

import './initComponents'

new Vue({
  render: h => h(App),
}).$mount('#app')

Vue.config.productionTip = false
Vue.config.devtools = true



// WEBPACK FOOTER //
// ./src/main.js